export const SCROLL_LINK_NODE_NAME = 'scrollLink';
